import { render, staticRenderFns } from "./DocumentUploadStep.vue?vue&type=template&id=e2da13be&scoped=true"
import script from "./DocumentUploadStep.vue?vue&type=script&lang=js"
export * from "./DocumentUploadStep.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploadStep.vue?vue&type=style&index=0&id=e2da13be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2da13be",
  null
  
)

export default component.exports